
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.17 7.27a.5.5 0 01-.45-.27l-2.11-4.18a.5.5 0 01.22-.68L17.06.05a.5.5 0 11.44.9l-3.77 1.87 1.88 3.73a.5.5 0 01-.22.67.5.5 0 01-.22.05z"}}),_c('path',{attrs:{"d":"M14.66 21.9a.5.5 0 01-.14-.97A9.3 9.3 0 0021 12a8.75 8.75 0 00-7.92-8.85.5.5 0 01-.44-.55.5.5 0 01.56-.44A9.84 9.84 0 0122 12a10.31 10.31 0 01-7.2 9.89.52.52 0 01-.14.02zM6.72 24a.5.5 0 01-.22-.95l3.77-1.87-1.88-3.73a.5.5 0 11.89-.45l2.11 4.18a.5.5 0 01-.22.68l-4.23 2.09a.5.5 0 01-.22.05z"}}),_c('path',{attrs:{"d":"M10.86 21.84a.43.43 0 01-.06 0A9.84 9.84 0 012 12a10.31 10.31 0 017.2-9.89.5.5 0 11.29.96A9.31 9.31 0 003 12a8.75 8.75 0 007.92 8.85.5.5 0 01-.06 1z"}})])
          )
        }
      }
    